import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { CoreService, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { Mapper, MapperBuilder, TRANSFORM } from 'src/app/helpers/mapper';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, QUESTION_CODES, SECTION_CODES } from 'src/app/constants/app-data.constants';
import { nameof } from 'src/app/helpers/nameof';
import { ConcessionsInvoiceGridFilterRequest } from 'src/app/interfaces/concessions-invoice-grid-filter-request.interface';

@Component({
  selector: 'app-concessions-invoice-list',
  templateUrl: './concessions-invoice-list.component.html',
  styleUrl: './concessions-invoice-list.component.scss'
})
export class ConcessionsInvoiceListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';
  applicationId: string = '';
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.concessionsInvoiceList,
      () => API_ENDPOINTS.dashboard.getConcessionsInvoices,
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.ConcessionsInvoiceListForm.invoiceNumberFilter, null, nameof<ConcessionsInvoiceGridFilterRequest>('invoiceNumber'))
        .MapFrom(FILTER_QUESTION_CODES.ConcessionsInvoiceListForm.invoiceFromDateFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.ConcessionsInvoiceListForm.invoiceToDateFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.ConcessionsInvoiceListForm.paymentNumberFilter, null, nameof<ConcessionsInvoiceGridFilterRequest>('paymentNumber'))
        .MapFrom(FILTER_QUESTION_CODES.ConcessionsInvoiceListForm.paymentFromDateFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.ConcessionsInvoiceListForm.paymentToDateFilter, TRANSFORM.STRING_TO_DATE)
        .BuildMapper();
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const applicationId = paramMap.get('id');
      if (applicationId) {
        this.applicationId = applicationId;
      }
    });
  }

  formLoad(event: any): void {
    const filterRequest = this.getFilterRequest();
    this.loadGridDataOnFormLoad(filterRequest);
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.concessionsInvoiceListForm.invoiceListFilter:
        {
          const filterRequest = this.getFilterRequest();
          this.loadGridData(filterRequest);
          break;
        }
    }
  }

  private getFilterRequest(): ConcessionsInvoiceGridFilterRequest {
    const filterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.concessionsInvoiceListForm.invoices,
      PAGE_NUMBERS.concessionsInvoiceListForm.invoices,
      SECTION_CODES.concessionsInvoiceListForm.invoiceSection,
      QUESTION_CODES.concessionsInvoiceListForm.invoiceListFilter
    );

    let filterRequest: ConcessionsInvoiceGridFilterRequest = {
      applicationId: ''
    };
    
    if (filterModel != null) {
      filterRequest = this.filterQuestionToFilterModelMapper.Map(filterModel);
    }
    filterRequest.applicationId = this.applicationId;
    return filterRequest;
  }
}